module.exports = __webpack_public_path__ + "images/emoji/ok_hand.6384193fe65b5cf61dac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ok_hand.png
// module id = j18c
// module chunks = 24